import posthog from '@leyan/lytics';
import { logger } from 'services/logger';

let accid = '';
export function setAccid(nimAccid: string) {
  accid = nimAccid;
}

/** nim 事件上报 */
export function nimEventReport(eventName: string, custInfo?: any, sdkVersion?: string) {
  posthog.capture('$yxNimEvent', {
    accid,
    eventName,
    custInfo,
    sdkVersion,
  });
  logger.info(
    `[NimEvent][${eventName}]: ${JSON.stringify({
      accid,
      custInfo,
      sdkVersion,
    })}`,
  );
}
